











































































































































import { Component, Prop } from 'vue-property-decorator';
import Form, { Send } from '@/components/form-base';
import { DialogForm, FormOverlay } from '@/components/bwaff';
import ErrorAggregator from '@/components/errors/error-aggregator.vue';

import HeaderButtons from '@/components/ui/ui-modal/modal/header-buttons.vue'
import ReportMetricsMixin from '@/views/reports/mixins/report-metrics-mixin';
import { mixins } from 'vue-class-component';
import ColumnsApi from '@/services/rest/bemob/custom-columns';
import ReportAPI from '@/services/rest/bemob/report';
import BemobApi from '@/services/rest/bemob';
import { METRICS_CUSTOM_COLUMN, METRICS_CUSTOM_EVENT, METRICS_CUSTOM_EVENT_REVENUE,METRICS_CUSTOM_EVENT_HIDDEN_REVENUE } from '@/services/constants/report';
const md5 = require('md5');


const braces = ['(', ')']
const operators = ['+', '-', '*', '/']

const separatorsReg = new RegExp(`([${['+', '-', '/(', '/)', '*', '/'].join('')}])`, 'g')

const getBoundaryRegex = word => new RegExp(word.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), 'g')

const identifier = /^{\d+}$/
const identifiers = /{(\d+)}/g

const sortByLength = arr => arr.sort((a, b) => b.text.length - a.text.length)
const checkIsEqual = (str1: string, str2: string): boolean => str1.toLowerCase() === str2.toLowerCase()

interface FormInterface {
  id: string | null,
  columnName: string,
  description: string,
  formula: object[],
  formulaText: string,
  format: string,
  decimals: number,
}

interface Format {
  id: string,
  name: string,
}

interface Decimals {
  id: number,
  name: string,
}

@Component({
  components: {
    FormOverlay,
    DialogForm,
    ErrorAggregator,
    HeaderButtons,
  }
})

export default class AddNewColumnDialog extends mixins<Form, ReportMetricsMixin>(Form, ReportMetricsMixin) {
  @Prop({ default: {} })
  data: any;

  show: boolean = false;
  loading: boolean = false;
  isEditing: boolean = false;
  columnsApi: ColumnsApi = new ColumnsApi();
  reportApi: ReportAPI = new ReportAPI();
  bemobApi: BemobApi = new BemobApi();
  errors: string[] = []
  errorsControlActive: boolean = false;
  formulaSelectionStart: number = 0;

  form: FormInterface = {
    ...this.defaultForm
  }

  oldHash: string = '';
  getCurrentHash() {
    return md5(JSON.stringify(this.form));
  }

  checkClose() {
    if (this.oldHash !== this.getCurrentHash()) {
      this.bus.emit('open-dialog', { name: 'ConfirmDialog', data: {
        onConfirm: () => this.close(),
      }})
    } else {
      this.close();
    }
  }

  mounted() {
    this.$on('error', (e: any) => {
      this.errors = this.translateErrors(this.parseErrors(e.data.errors), e.data.message);
      this.errorsControlActive = true;
    });

    this.form = { ...this.defaultForm };
    this.resetErrorsWithControl()

    const { item } = this.data
    if (item) {
      const { id, text: columnName, description, formula, format, decimalPlaces } = item
      this.form.formulaText = formula.replace(/{(.+?)}/g, (_, value) => this.getMetricsByValue(value))

      this.form = {
        ...this.form,
        id,
        columnName,
        description,
        formula: this.formula,
        format,
        decimals: decimalPlaces,
      }
    }

    this.oldHash = this.getCurrentHash()
    this.show = true;
  }

  resetErrorsWithControl(): void {
    this.errors = [];
    this.errorsControlActive = false;

    this.resetErrors();
  }

  get defaultForm(): FormInterface {
    return {
      id: null,
      columnName: '',
      description: '',
      formula: [],
      formulaText: '',
      format: this.formatTypes[0].id,
      decimals: this.decimals[0].id,
    }
  }

  get formatTypes(): Format[] {
    return [
      {
        id: 'number',
        name: this.t('Number'),
      },
      {
        id: 'percent',
        name: this.t('Percent'),
      },
      {
        id: 'currency',
        name: this.t('Currency'),
      },
    ]
  }

  get decimals(): Decimals[] {
    return [
      {
        id: 0,
        name: '0',
      },
      {
        id: 1,
        name: '1',
      },
      {
        id: 2,
        name: '2',
      },
      {
        id: 3,
        name: '3',
      },
      {
        id: 4,
        name: '4',
      },
    ]
  }

  get sortedColumns() {
    return sortByLength([...this.metrics])
  }

  get metrics() {
    const { metrics } = this.$store.state.reportColumns;

    const archived = Object.values(this.$store.state.table.customEvents).reduce((acc: any, item: any) => {
      if (item.status === 'archived') {
        acc.push({
          value: `${METRICS_CUSTOM_EVENT}${item.slug}`,
          text: item.name,
          archived: true,
        })
        acc.push({
          value: `${METRICS_CUSTOM_EVENT_REVENUE}${item.slug}`,
          text: `${item.name} (revenue)`,
          archived: true,
        })
        acc.push({
          value: `${METRICS_CUSTOM_EVENT_HIDDEN_REVENUE}${item.slug}`,
          text: `${item.name} (Hidden Revenue)`,
          archived: true,
        })
      }
      return acc
    }, [])

    return metrics
      .filter(name => !name.startsWith(METRICS_CUSTOM_COLUMN))
      .map(name => ({
        text: this.reportMetricsName(name),
        value: name,
      }))
      .concat(archived)
  }

  get activeMetrics() {
    return this.metrics.filter(({ archived }) => !archived)
  }

  get formulaWithIdentifier() {
    return this.sortedColumns
      .reduce((acc, { text }, i) => acc.replace(getBoundaryRegex(text), `{${i}}`),  this.form.formulaText)
      .split(separatorsReg)
      .filter(token => token);
  }

  get formula() {
    return this.formulaWithIdentifier.map((token, i) => {
      const value = token.trim()

      if (identifier.test(value)) {
        const column = this.sortedColumns[value.slice(1, -1)]
        return {
          value: column.value,
          text: token.replace(identifiers, (_, val) => this.sortedColumns[val].text),
          color: column.archived ? this.$colors.tangerine : this.$colors.green,
        }
      }

      if (braces.includes(value) || (operators.includes(value) && !operators.includes(this.formulaWithIdentifier[i - 1]))) {
        return {
          text: token,
          value: token,
          color: this.$colors.blue
        }
      }

      if (!isNaN(value)) {
        return {
          text: token,
          value: token,
          color: this.$colors.violet
        }
      }

      const text = token.replace(identifiers, (_, val) => this.sortedColumns[val].text)

      return {
        text,
        value: text,
        color: this.$colors.red,

      }

    })
  }

  handleChange() {
    this.form.formula = this.formula
  }

  formulaBlur() {
    const { selectionStart } = this.$refs.formula as any
    this.formulaSelectionStart = selectionStart;
  }

  addText(text: string): void {
    this.form.formulaText = this.form.formulaText.substring(0, this.formulaSelectionStart)
      + text
      + this.form.formulaText.substring(this.formulaSelectionStart);
    this.form.formula = this.formula;

    this.formulaSelectionStart = this.formulaSelectionStart + text.length;
  }

  clickChip({ text }: { text: string}): void {
    this.addText(text)
  }

  getEntityByName(name: string): object {
    return this.data.inheritMetrics?.find(({ text }) => checkIsEqual(text, name))
  }

  @Send(true)
  submit() {
    this.resetErrors();
    this.resetErrorsWithControl()

    const { id, columnName: name, description, format, decimals: decimalPlaces } = this.form
    const entity = this.getEntityByName(name) as any

    if (entity && entity.id !== id) {
      const errorText = this.t('{0} is already taken', [this.t('Name')])
      this.state['name:error'] = errorText
      this.errors.push(errorText)
      this.errorsControlActive = true;
      return;
    }

    const formula = this.sortedColumns.reduce((acc, { value },i) =>
      acc.replaceAll(`{${i}}`, `{${value}}`), this.formulaWithIdentifier.join(''))

    const params = {
      ...(id && { id }),
      name,
      formula,
      format,
      decimalPlaces,
      status: 'active',
      description
    }

    const promise = id ? this.columnsApi.put(params) : this.columnsApi.post(params)

    return promise.then((createNewColumnResponse) => {
      Promise.all([this.reportApi.getSupportedMetrics(), this.bemobApi.getCustomColumns()])
        .then((response) => {
          this.bus.emit('update-custom-columns',{
            action: id ? 'edit' : 'add',
            item:createNewColumnResponse,
            groupIndex:this.data.groupIndex
          })
          this.close()
        })
    })
  }

  getMetricsByValue(value) {
    return this.metrics.reduce((acc, { text, value }) => {
      acc[value] = text
      return acc
    }, {})[value]
  }

  close() {
    this.$emit('close');
  }
}
